module.exports = __webpack_public_path__ + "img/attention.a2d0322.png";